import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { AppComponent } from 'src/app/app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LoginComponent } from 'src/app/modules/login/login.component';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { JwtInterceptor, ErrorInterceptor } from './helpers';
import { SharedConstants } from 'src/app/models';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ToastrModule } from 'ngx-toastr';
import { SidebarDirective } from 'src/app/side.directive';
import { MAT_DATE_LOCALE, MatNativeDateModule, MatRippleModule} from '@angular/material/core';
import { DialogoConfirmacionComponent } from 'src/app/models/shared/dialogo-confirmacion/dialogo-confirmacion.component';
import { LottieModule } from 'ngx-lottie';
import player from 'lottie-web';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgxPaginationModule } from 'ngx-pagination';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { FilterPipe } from 'src/app/Pipes/filter.pipes';
import { ListHistoryComponent } from "src/app/modules/history/list-history.component";
import { ListDocumentsComponent } from 'src/app/modules/management/document/list-documents.component';
import { InputCheckComponent } from 'src/app/Components/input-check/input-check.component';
import { HeaderComponent } from 'src/app/Components/header/header.component';
import { ChartModule } from 'angular2-chartjs';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { ModalModule } from 'ngx-bootstrap/modal';

import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatStepperModule } from '@angular/material/stepper';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatListModule } from '@angular/material/list';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PageNotFoundComponent } from './modules/shared/page-not-found/page-not-found.component';
import { ListCompanyComponent } from './modules/management/company/list-company.component';
import { RollCallComponent } from './modules/roll-call/roll-call.component';
import { SuccessfulManualAcceptanceComponent } from './modules/management/successful-manual-acceptance/successful-manual-acceptance.component';
import { DetailCompanyComponent } from './modules/management/company/detail-company.component';
import { CreateCompanyComponent } from './modules/management/company/create-company.component';
import { EditCompanyComponent } from './modules/management/company/edit-company.component';
import { NgxSummernoteModule } from 'ngx-summernote';
import { DocumentEditorModule, DocumentEditorContainerModule } from '@syncfusion/ej2-angular-documenteditor';
import { FooterComponent } from './modules/shared/footer/footer.component';
import { HeaderEmiComponent } from './modules/shared/header/header-emi.component';
import { DetailsWokingDayComponent } from './modules/management/branch-CAE/components/details-woking-day/details-woking-day.component';

import {MatMenuModule} from '@angular/material/menu';
import { MenuItemComponent } from "./modules/shared/menu-item/menu-item.component";
import { SharedModule } from './modules/shared/shared.module';
import { TableControlComponent } from "./modules/roll-call/Components/table-control/table-control.component";
import { FilterControlComponent } from "./modules/roll-call/Components/filter-control/filter-control.component";
import { PaginationComponent } from "./modules/roll-call/Components/pagination/pagination.component";
import { ModalDetailRegisterComponent } from "./modules/roll-call/Components/modal-detail-register/modal-detail-register.component";
import { EmiMapComponent } from "./modules/shared/emi-map/emi-map.component";

import { LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';

// Registrar el locale español
registerLocaleData(localeEs);

export function initializeApp(sharedConstants: SharedConstants) {
    return () => sharedConstants.loadApiServer();
}

export function playerFactory() {
    return player;
}

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, '/assets/i18n/', '.json');
}


@NgModule({
    declarations: [
        AppComponent,
        LoginComponent,
        SidebarDirective,
        DialogoConfirmacionComponent,
        FilterPipe,
        HeaderComponent,
        HeaderEmiComponent,
        InputCheckComponent,
        ListHistoryComponent,
        ListDocumentsComponent,
        PageNotFoundComponent,
        RollCallComponent,
        DetailsWokingDayComponent,
        SuccessfulManualAcceptanceComponent,
        ListCompanyComponent,
        CreateCompanyComponent,
        EditCompanyComponent,
        DetailCompanyComponent,
        FooterComponent
    ],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        {
            provide: APP_INITIALIZER,
            useFactory: initializeApp,
            deps: [SharedConstants], multi: true
        },
        { provide: MAT_DATE_LOCALE, useValue: 'es' },
    ],
    bootstrap: [AppComponent],
    imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    FormsModule,
    FontAwesomeModule,
    HttpClientModule,
    ChartModule,
    ModalModule.forRoot(),
    ToastrModule.forRoot(),
    MatInputModule,
    MatFormFieldModule,
    MatSlideToggleModule,
    MatTableModule,
    MatCheckboxModule,
    MatRadioModule,
    MatCardModule,
    MatButtonModule,
    MatMenuModule,
    MatNativeDateModule,
    MatRippleModule,
    MatTooltipModule,
    MatDatepickerModule,
    MatSelectModule,
    MatTabsModule,
    MatButtonToggleModule,
    MatExpansionModule,
    MatStepperModule,
    MatIconModule,
    MatAutocompleteModule,
    MatListModule,
    NgbModule,
    MatProgressSpinnerModule,
    NgxPaginationModule,
    PaginationModule.forRoot(),
    TooltipModule.forRoot(),
    LottieModule.forRoot({ player: playerFactory }),
    TranslateModule.forRoot({
        loader: {
            provide: TranslateLoader,
            useFactory: (createTranslateLoader),
            deps: [HttpClient]
        }
    }),
    NgxSummernoteModule,
    DocumentEditorModule,
    DocumentEditorContainerModule,
    MenuItemComponent,
    SharedModule,
    TableControlComponent,
    FilterControlComponent,
    PaginationComponent,
    ModalDetailRegisterComponent,
    EmiMapComponent
]
})
export class AppModule { }
